import Box from "@mui/material/Box";
import SectionHeader from "./section-header";
import { SectionBox } from "src/lib/components/category-list-section/footmart/styles"; // ==============================================================

// ==============================================================
const SectionCreator = (props) => {
  const { icon, title, subTitle, children, seeMoreLink, bgColor, ...others } = props;
  return (
    <Box mb={7.5} {...others}>
      <SectionBox bgColor={bgColor}>
        {title ? (
          <SectionHeader title={title} subTitle={subTitle} seeMoreLink={seeMoreLink} icon={icon} />
        ) : null}

        {children}
      </SectionBox>
    </Box>
  );
};

export default SectionCreator;
